import * as z from "zod/v4/mini";
export class ProtocolSchemas {
    static number() {
        return z
            .custom(() => true)
            .check(z.check((context) => {
            if (typeof context.value !== "number" ||
                Number.isNaN(context.value)) {
                context.issues.push({
                    code: "invalid_type",
                    expected: "number",
                    input: context.value,
                });
            }
        }));
    }
    static nonnegativeInteger() {
        return ProtocolSchemas.number().check(z.check((context) => {
            if (!Number.isInteger(context.value)) {
                context.issues.push({
                    code: "invalid_type",
                    expected: "int",
                    input: context.value,
                    continue: true,
                });
            }
        }), z.gte(0));
    }
}
//# sourceMappingURL=protocol-schemas.js.map